import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faApple,
  faGooglePlay,
  faInstagram,
  faTiktok,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import {
  // Icons we'll use in the app
  faMessage,
  faPlus,
  faArrowRightFromBracket,
  faArrowLeft,
  faSun,
  faMoon,
  faPaperPlane,
  faSpinner,
  faHome,
  faComments,
  faTrash,
  faEdit,
  faCog,
  faUser,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faEllipsisV,
  faBars,
  faCircleQuestion,
  faTimes,
  faSearch,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faBell,
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
  faTimesCircle,
  faChartBar,
  faChartLine,
  faLightbulb,
  faBug,
  faWrench,
  faCode,
  faRobot,
  faTerminal,
  faBook,
  faBrain,
  faCloudArrowUp,
  faLock,
  faUnlock,
  faLockOpen,
  faImage,
  faShareNodes,
  faXmark,
  faUsers,
  faEye,
  faEyeSlash,
  faPause,
  faPlay,
  faFileText,
  faCalendarAlt,
  faExternalLinkAlt,
  faEnvelope,
  faIdCard,
  faShieldAlt,
  faFrown,
  faRefresh,
  faClock,
  faSkull,
  faCheck,
  faClipboard,
  faCircle,
  faSquare,
  faCircleInfo,
  faBullseye,
  faVideo,
  faChartArea,
  faChartPie,
  faUpDown,
  faBookOpen,
  faEuroSign,
  faDollarSign,
  faSave,
  faGraduationCap,
  faGlobe,
  faDownload,
  faStar,
  faMoneyBillWave,
  faEllipsisH,
  faKey,
  faUpload,
  faRepeat,
  faArrowsRotate,
  faFileCsv,
  faBolt,
  faRocket,
  faCalendarDay,
  faArrowTrendUp,
  faArrowTrendDown,
  faToggleOn,
  faToggleOff,
  faFlagCheckered,
  faCircleCheck,
  faTriangleExclamation,
  faCircleXmark,
  faTrafficLight,
  faUnlink,
  faLink,
  faCreditCard,
  faFileContract,
  faCloud,
  faTag,
  faRoute,
  faBoxOpen,
  faArrowUp,
  faArrowRight,
  faRightLeft,
  faUserGroup,
  faCookieBite,
  faGift,
  faUserCheck,
  faUserXmark,
  faServer,
  faPlug,
  faDatabase,
  faUserSecret,
  faList,
  faCalculator,
  faMinus,
  faVolumeHigh,
  faVolumeXmark,
  faWindowMinimize,
  faCirclePlus,
  faPhone,
  faGripVertical,
  faExpand,
  faCompress,
  faPen,
  faStarHalfStroke,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';

import { faPlayCircle as faPlayCircleSolid, faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';

import { faDisplayChartUpCircleDollar } from '@fortawesome/pro-regular-svg-icons';
import {
  faMemoCircleInfo,
  faHexagonNodesBolt,
  faStarfighterTwinIonEngine,
  faClonePlus,
  faTrashPlus,
  faHexagonExclamation,
  faMagnifyingGlassPlay,
} from '@fortawesome/pro-solid-svg-icons';

// Re-export regular icon with new name to avoid conflict
export { faPlayCircleSolid as faPlayCircle };

// Add icons to the library
library.add(
  faApple,
  faGooglePlay,
  faInstagram,
  faTiktok,
  faXTwitter,
  faMessage,
  faPlus,
  faArrowRightFromBracket,
  faArrowLeft,
  faSun,
  faMoon,
  faPaperPlane,
  faSpinner,
  faHome,
  faComments,
  faTrash,
  faEdit,
  faCog,
  faUser,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faEllipsisV,
  faBars,
  faCircleQuestion,
  faTimes,
  faSearch,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faBell,
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
  faTimesCircle,
  faChartBar,
  faChartLine,
  faLightbulb,
  faBug,
  faWrench,
  faCode,
  faRobot,
  faTerminal,
  faBook,
  faBrain,
  faCloudArrowUp,
  faLock,
  faUnlock,
  faLockOpen,
  faImage,
  faShareNodes,
  faXmark,
  faUsers,
  faEye,
  faEyeSlash,
  faPause,
  faPlay,
  faPlayCircleSolid,
  faFileText,
  faCalendarAlt,
  faExternalLinkAlt,
  faEnvelope,
  faIdCard,
  faShieldAlt,
  faFrown,
  faRefresh,
  faClock,
  faSkull,
  faCheck,
  faClipboard,
  faCircleInfo,
  faCircle,
  faSquare,
  faBullseye,
  faVideo,
  faChartArea,
  faChartPie,
  faUpDown,
  faBookOpen,
  faEuroSign,
  faDollarSign,
  faSave,
  faGraduationCap,
  faGlobe,
  faDownload,
  faStar,
  faMoneyBillWave,
  faEllipsisH,
  faKey,
  faUpload,
  faRepeat,
  faArrowsRotate,
  faFileCsv,
  faBolt,
  faRocket,
  faCalendarDay,
  faArrowTrendUp,
  faArrowTrendDown,
  faToggleOn,
  faToggleOff,
  faFlagCheckered,
  faCircleCheck,
  faTriangleExclamation,
  faCircleXmark,
  faTrafficLight,
  faUnlink,
  faLink,
  faCreditCard,
  faFileContract,
  faCloud,
  faTag,
  faRoute,
  faBoxOpen,
  faArrowUp,
  faArrowRight,
  faRightLeft,
  faUserGroup,
  faCookieBite,
  faGift,
  faUserCheck,
  faUserXmark,
  faServer,
  faPlug,
  faDatabase,
  faUserSecret,
  faDisplayChartUpCircleDollar,
  faMemoCircleInfo,
  faList,
  faHexagonNodesBolt,
  faCalculator,
  faMinus,
  faStarfighterTwinIonEngine,
  faVolumeHigh,
  faVolumeXmark,
  faClonePlus,
  faWindowMinimize,
  faCirclePlus,
  faTrashPlus,
  faHexagonExclamation,
  faMagnifyingGlassPlay,
  faPhone,
  faGripVertical,
  faExpand,
  faCompress,
  faPen,
  faStarHalfStroke,
  faHeart,
  faHeartRegular,
);

// Export for use in components
export {
  faApple,
  faGooglePlay,
  faInstagram,
  faTiktok,
  faXTwitter,
  faMessage,
  faPlus,
  faArrowRightFromBracket,
  faArrowLeft,
  faSun,
  faMoon,
  faPaperPlane,
  faSpinner,
  faHome,
  faComments,
  faTrash,
  faEdit,
  faCog,
  faUser,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faEllipsisV,
  faBars,
  faCircleQuestion,
  faTimes,
  faSearch,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faBell,
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
  faTimesCircle,
  faChartBar,
  faChartLine,
  faLightbulb,
  faBug,
  faWrench,
  faCode,
  faRobot,
  faTerminal,
  faBook,
  faBrain,
  faCloudArrowUp,
  faLock,
  faUnlock,
  faLockOpen,
  faImage,
  faShareNodes,
  faXmark,
  faUsers,
  faEye,
  faEyeSlash,
  faPause,
  faPlay,
  faFileText,
  faCalendarAlt,
  faExternalLinkAlt,
  faEnvelope,
  faIdCard,
  faShieldAlt,
  faFrown,
  faRefresh,
  faClock,
  faSkull,
  faCheck,
  faClipboard,
  faCircleInfo,
  faCircle,
  faSquare,
  faBullseye,
  faVideo,
  faChartArea,
  faChartPie,
  faUpDown,
  faBookOpen,
  faEuroSign,
  faDollarSign,
  faSave,
  faGraduationCap,
  faGlobe,
  faDownload,
  faStar,
  faMoneyBillWave,
  faEllipsisH,
  faKey,
  faUpload,
  faRepeat,
  faArrowsRotate,
  faFileCsv,
  faBolt,
  faRocket,
  faCalendarDay,
  faArrowTrendUp,
  faArrowTrendDown,
  faToggleOn,
  faToggleOff,
  faFlagCheckered,
  faCircleCheck,
  faTriangleExclamation,
  faCircleXmark,
  faTrafficLight,
  faUnlink,
  faLink,
  faCreditCard,
  faFileContract,
  faCloud,
  faTag,
  faRoute,
  faBoxOpen,
  faArrowUp,
  faArrowRight,
  faRightLeft,
  faUserGroup,
  faCookieBite,
  faGift,
  faUserCheck,
  faUserXmark,
  faServer,
  faPlug,
  faDatabase,
  faUserSecret,
  faDisplayChartUpCircleDollar,
  faMemoCircleInfo,
  faList,
  faHexagonNodesBolt,
  faCalculator,
  faMinus,
  faStarfighterTwinIonEngine,
  faVolumeHigh,
  faVolumeXmark,
  faClonePlus,
  faWindowMinimize,
  faCirclePlus,
  faTrashPlus,
  faHexagonExclamation,
  faMagnifyingGlassPlay,
  faPhone,
  faGripVertical,
  faExpand,
  faCompress,
  faPen,
  faStarHalfStroke,
  faHeart,
  faHeartRegular,
};
